import { render, staticRenderFns } from "./PageShop.vue?vue&type=template&id=2930e8dc&scoped=true&"
import script from "./PageShop.vue?vue&type=script&lang=js&"
export * from "./PageShop.vue?vue&type=script&lang=js&"
import style0 from "./PageShop.vue?vue&type=style&index=0&id=2930e8dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2930e8dc",
  null
  
)

export default component.exports